import { render, staticRenderFns } from "./NewBusinessView.vue?vue&type=template&id=241dd3c3&scoped=true&"
import script from "./NewBusinessView.vue?vue&type=script&lang=ts&"
export * from "./NewBusinessView.vue?vue&type=script&lang=ts&"
import style0 from "./NewBusinessView.vue?vue&type=style&index=0&id=241dd3c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241dd3c3",
  null
  
)

export default component.exports